var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgH2Icon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.2152 10.6076C21.2152 15.9039 15.3397 21.4198 13.3667 23.1234C13.1829 23.2616 12.9591 23.3364 12.7292 23.3364C12.4992 23.3364 12.2755 23.2616 12.0917 23.1234C10.1187 21.4198 4.24316 15.9039 4.24316 10.6076C4.24316 8.35697 5.13722 6.19852 6.72866 4.60708C8.3201 3.01564 10.4785 2.12158 12.7292 2.12158C14.9798 2.12158 17.1383 3.01564 18.7297 4.60708C20.3211 6.19852 21.2152 8.35697 21.2152 10.6076Z",
    stroke: "white",
    strokeWidth: 2.1215,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7291 13.7896C14.4866 13.7896 15.9114 12.3648 15.9114 10.6073C15.9114 8.84979 14.4866 7.42505 12.7291 7.42505C10.9716 7.42505 9.54688 8.84979 9.54688 10.6073C9.54688 12.3648 10.9716 13.7896 12.7291 13.7896Z",
    stroke: "white",
    strokeWidth: 2.1215,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgH2Icon);
export default __webpack_public_path__ + "static/media/h2Icon.7f733c5e02a9c3d4e21492467f50da48.svg";
export { ForwardRef as ReactComponent };